module.exports = __webpack_public_path__ + "static/img/private-shop.50dcf9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/private-shop.png
// module id = Z6er
// module chunks = 2